// src/components/Footer.js
import React from 'react';
import './Footer.css';

const Footer = () => {

  return (
    <footer className="footer rtl">
      <div className="container">
        <div className="footer-content">
          <p className="copyright">2026 Aullan LLC</p>
          <div className="footer-links">

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
